// extracted by mini-css-extract-plugin
module.exports = {"error":"#e15a55"};